import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as modelHelper from "../../../helpers/modelHelper";

import BarcodeImage from "../BarcodeImage";
import Modal from "../generic/Modal";

class ShowBarcodeModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseStockModalAction();
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.props.params.label)}
                content={modelHelper.buildModalSection(<BarcodeImage id="barcode-modal-img" height="200px" />)}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SHOW_BARCODE_MODAL));
        }
    };
};

export default ShowBarcodeModal = connect(mapStoreToProps, mapDispatchToProps)(ShowBarcodeModal);
